import React from 'react';
import { Box } from '@mui/material';

import { BoolField } from '../dynamic-fields/BoolField';
import { ChoiceField } from '../dynamic-fields/ChoiceField';
import { DateField } from '../dynamic-fields/DateField';
import { DateTimeField } from '../dynamic-fields/DateTimeField';
import { MultiChoiceField } from '../dynamic-fields/MultiChoiceField';
import { CharField } from '../dynamic-fields/CharField';
import { TimeField } from '../dynamic-fields/TimeField';
import { NumberField } from '../dynamic-fields/NumberField';
import { RadioChoiceField } from '../dynamic-fields/RadioChoiceField';
import { OnChangeCharField } from '../dynamic-fields/OnChangeCharField';
import { InfoField } from '../dynamic-fields/InfoField';

export const FormFieldPanel = props => {
  const { field, formik, updateOptionsCallback, getFieldCallback, setLoadingCallback, yupRequiredFieldsCallback, bigFamilyCardCallback, updateDiscountsCallback, historicDataByPeselCallback, checkActivitiesCallback, setDateToCallback, hideFieldCallback, handleDiscountActions, handleParishChange, handleGroupChange, handleEventChange, handlePeriodChange, handleSourceOfOfferChange, formVersion } = props;

  return (
    <Box>
      {
        field.type === 'char' && !field.on_change
          ? <CharField type="char" field={field} formik={formik} getFieldCallback={getFieldCallback} />
          : field.type === 'char' && field.on_change
            ? <OnChangeCharField type="char" field={field} formik={formik} getFieldCallback={getFieldCallback} updateDiscountsCallback={updateDiscountsCallback} historicDataByPeselCallback={historicDataByPeselCallback} />
            : field.type === 'text'
              ? <CharField type="text" field={field} formik={formik} getFieldCallback={getFieldCallback} />
              : field.type === 'bool'
                ? <BoolField field={field} formik={formik} getFieldCallback={getFieldCallback} yupRequiredFieldsCallback={yupRequiredFieldsCallback} updateOptionsCallback={updateOptionsCallback} setLoadingCallback={setLoadingCallback} />
                : field.type === 'choice'
                  ? <ChoiceField field={field} formik={formik} updateOptionsCallback={updateOptionsCallback} getFieldCallback={getFieldCallback} setLoadingCallback={setLoadingCallback} hideFieldCallback={hideFieldCallback} yupRequiredFieldsCallback={yupRequiredFieldsCallback} handleDiscountActions={handleDiscountActions} handleParishChange={handleParishChange} handleGroupChange={handleGroupChange} handleEventChange={handleEventChange} handlePeriodChange={handlePeriodChange} handleSourceOfOfferChange={handleSourceOfOfferChange} />
                  : field.type === 'multichoice'
                    ? <MultiChoiceField field={field} formik={formik} getFieldCallback={getFieldCallback} checkActivitiesCallback={checkActivitiesCallback} formVersion={formVersion} />
                    : field.type === 'radiochoice'
                      ? <RadioChoiceField field={field} formik={formik} getFieldCallback={getFieldCallback} yupRequiredFieldsCallback={yupRequiredFieldsCallback} bigFamilyCardCallback={bigFamilyCardCallback} />
                      : field.type === 'date'
                        ? <DateField field={field} formik={formik} getFieldCallback={getFieldCallback} updateOptionsCallback={updateOptionsCallback} setLoadingCallback={setLoadingCallback} setDateToCallback={setDateToCallback} formVersion={formVersion} />
                        : field.type === 'time'
                          ? <TimeField field={field} formik={formik} getFieldCallback={getFieldCallback} />
                          : field.type === 'datetime'
                            ? <DateTimeField field={field} formik={formik} getFieldCallback={getFieldCallback} />
                            : field.type === 'number'
                              ? <NumberField field={field} formik={formik} getFieldCallback={getFieldCallback} />
                              : field.type === 'button'
                                ? null
                                : field.type === 'info'
                                  ? <InfoField info={field} formikValues={formik.values} getFieldCallback={getFieldCallback} />
                                  : null
      }
    </Box>
  );
};
